import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import { StyledContainer, StyledSection } from './JuniorsWhy.styled';

const JuniorsWhy: React.FC = () => {
  const { t } = useI18n('helping-companies');

  return (
    <StyledSection>
      <StyledContainer>
        <img src={getPublicPath(`/images/helpingCompanies/why.svg`)} alt="" />
        <div>
          <Heading2 editorial alignLeft>
            {t('helping-companies.why.title')}
          </Heading2>
          <div>
            <HtmlTrans
              ns={'helping-companies'}
              i18nKey={'helping-companies.why.desc'}
            ></HtmlTrans>
          </div>
        </div>
      </StyledContainer>
    </StyledSection>
  );
};

export default JuniorsWhy;
